/** Socket + clock health, shown in the header and used to disable betting. */
import { create } from "zustand";

export type ConnectionStatus = "idle" | "connecting" | "connected" | "reconnecting" | "disconnected";

export interface ConnectionStore {
  status: ConnectionStatus;
  /** Median round-trip time from the clock samples, ms. */
  latencyMs: number;
  /** False until the first ping/pong completes — betting stays disabled. */
  clockSynced: boolean;
  setStatus: (status: ConnectionStatus) => void;
  setClockHealth: (health: { latencyMs: number; synced: boolean }) => void;
}

export const useConnectionStore = create<ConnectionStore>()((set) => ({
  status: "idle",
  latencyMs: 0,
  clockSynced: false,
  setStatus: (status) => set({ status }),
  setClockHealth: ({ latencyMs, synced }) => set({ latencyMs, clockSynced: synced }),
}));

/** Betting is only safe when we are connected AND the clock is trusted. */
export const selectCanBet = (s: ConnectionStore): boolean => s.status === "connected" && s.clockSynced;
